import { useState } from "react";
import { storyblokEditable } from "@storyblok/react";
import classNames from "classnames";
import { useCurrentUser } from "@hooks/use-current-user";
import Badge from "@components/core/Badge";
import Button from "@components/core/Button/Button";
import GroupLinksHeader from "./GroupLinksHeader";
import NavsearchLink from "./NavsearchLink";

function NavsearchGroupLinks({ blok }) {
  const user = useCurrentUser();
  const userGroup = user?.user_group || "visitor";

  const [openNavLinksSection, setOpenNavLinksSection] = useState(false);

  if (!blok) return null;

  return (
    <div
      key={blok._uid}
      {...storyblokEditable(blok)}
    >
      <div
        className={classNames(
          "group-links-container",
          openNavLinksSection && "group-links-container-open",
        )}
      >
        <GroupLinksHeader
          groupLinksHeader
          blok={blok}
          setOpenNavLinksSection={setOpenNavLinksSection}
        />
        {blok.links?.map((links, index) => (
          <NavsearchLink
            key={`${blok._uid}-${index}`}
            blok={links}
            parentTitle={blok.title}
          />
        ))}
      </div>

      <div
        className={classNames(
          blok.container_with_bottom_spacing && "container-with-bottom-spacing",
        )}
      >
        <Button
          key={blok._uid}
          variant={blok.link_class}
          className="no-underline navsearch-link-btn bg-white navsearch-btn short-padding"
          spaceBetween
          rightIconName="chevron-right"
          fullWidth
          trackingName="navsearchGroupLinksTitle"
          title={blok.title}
          userGroup={userGroup}
          onClick={() => setOpenNavLinksSection(true)}
        >
          <div className="navsearch-link-content">
            <p className="mb-0 text-1-line">{blok.title}</p>
            {blok.with_badge && (
              <Badge
                variant={blok.badge_variant || "light-primary"}
                iconName={blok.badge_icon}
                className="ms-2"
              >
                {blok.badge_text || "Ajouter votre texte"}
              </Badge>
            )}
          </div>
        </Button>
      </div>
    </div>
  );
}

export default NavsearchGroupLinks;
